<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

defineOptions({
  name: 'DisciplineTutorReasonOption',
})

defineProps<{
  text: string
  description: string
  selected: boolean
}>()
</script>

<template>
  <div :class="['discipline-tutor-reason-option', { selected }]">
    <AppText
      name="body1"
      :color="selected ? 'blue-600' : 'slate-900'"
    >
      {{ text }}
    </AppText>
    <AppText
      v-if="description"
      name="body2"
      color="slate-500"
    >
      {{ description }}
    </AppText>
  </div>
</template>

<style scoped lang="scss" src="./DisciplineTutorReasonOption.scss" />
